export const SnapshotResult = () => {
    return (
        <></>
    );
};